(() => {
  const header = document.querySelector('.cas-header');
  if (!header) return;

  const menuItems = Array.from(header.querySelectorAll('.cas-nav-item'));
  if (!menuItems.length) return;

  const closeAll = (exceptItem = null) => {
    menuItems.forEach((item) => {
      if (item !== exceptItem) item.removeAttribute('open');
    });
  };

  menuItems.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open) closeAll(item);
    });
  });

  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest('.cas-header')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
